import { IAnalyticsUser } from '../../types/analytics';
import { IApplicationState } from '../../types/redux';
import { selectUser } from '../user';

export const selectAnalyticsUser = (state: IApplicationState): IAnalyticsUser => {
  const user = selectUser(state);

  if (!user.isAuthenticated) {
    return {};
  }

  return {
    userId: user.userId,
  };
};
